const SWAP_FEE_SATS = 1;
const MIN_PRICE_SATS = 2;
const IMAGE_OPTIMIZATION_SATS = 21;
const VIDEO_THUMBNAIL_SATS = 21;
const VIDEO_TRANSCODE_SATS_PER_MB = 21;

export function calculatePriceSats(contentLengthBytes: number): number {
  const sizeMB = contentLengthBytes / 1_000_000;
  return Math.max(Math.ceil(sizeMB) + SWAP_FEE_SATS, MIN_PRICE_SATS);
}

export function calculateMediaPriceSats(
  file: { type: string; size: number },
  videoMode: 'thumbnail' | 'transcode' = 'thumbnail',
): number {
  if (file.type.startsWith('image/')) return IMAGE_OPTIMIZATION_SATS;
  if (file.type.startsWith('video/')) {
    if (videoMode === 'thumbnail') return VIDEO_THUMBNAIL_SATS;
    const sizeMB = file.size / 1_000_000;
    return Math.max(IMAGE_OPTIMIZATION_SATS, Math.ceil(sizeMB) * VIDEO_TRANSCODE_SATS_PER_MB);
  }
  return 0;
}
